import View from './index';
import packageJson from '../../package.json';
import './view.scss';
import { getCommonOpenUtil } from '@/common/util';
console.log(`%cCN_UI_LOWCODE %c${packageJson?.version}`, 'color:#000;font-weight:bold;', 'color:green;font-weight:bold;');
export default View;
/**
 * 通用的辅助方法，供 L2 业务组件使用，挂载在 window 上
 */
window.cnLowCodeUtils = {
    ...getCommonOpenUtil(),
};
